module.exports = __webpack_public_path__ + "71bc22d8f5b13e99751547410b88b8d4.png";